import React from "react";
import { ClientsOnlyAppWall, useClientsOnlySession } from '@/components/authnz/ClientsOnlyAppWall';
import PageLayout from '@/components/shared/PageLayout';
import PostureAnalysisApp from "@/components/posture-analysis/posture-analysis-app";
import { PostureModeProvider } from '@/components/posture-analysis/lib/PostureModeContext';
import { PRACTITIONER_STRATEGY } from '@/components/posture-analysis/lib/posture-mode-strategy';

/**
 * Authenticated `/posture-analysis` — always practitioner mode (client save/load, four views, etc.).
 * Public self-assessment uses `/self-assessment` with `SELF_ASSESSMENT_STRATEGY` in App.tsx.
 */
export default function PostureAnalysisPage() {
  const clientsOnly = useClientsOnlySession();
  if (clientsOnly) {
    return (
      <PageLayout title="Posture Analysis" compactContent>
        <ClientsOnlyAppWall />
      </PageLayout>
    );
  }

  return (
    <PageLayout
      title="Posture Analysis"
      subtitle="Capture and analyze posture from multiple views"
      coachHint="Capture all four views, then save — I can explain plumb-line deviations and classification once analysis completes."
      compactContent
      fullBleed
    >
      <PostureModeProvider mode={PRACTITIONER_STRATEGY}>
        <PostureAnalysisApp />
      </PostureModeProvider>
    </PageLayout>
  );
}
